import * as React from 'react';

export const CordedRight: Function = (
  props: React.SVGProps<SVGSVGElement>,
): JSX.Element => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 103.26 63.58"
      {...props}
    >
      <g id="Group_75" data-name="Group 75">
        <g id="Group_37" data-name="Group 37">
          <g id="Group_615" data-name="Group 615">
            <rect
              id="Rectangle_111"
              data-name="Rectangle 111"
              fill="#fff"
              x="5.4"
              y="2.35"
              width="85.71"
              height="60.66"
            />
            <path
              id="Path_2469"
              data-name="Path 2469"
              fill="#dcd9d5"
              d="M91.11,63.58H5.4A.58.58,0,0,1,4.83,63V2.35a.58.58,0,0,1,.57-.57H91.11a.57.57,0,0,1,.57.57h0V63A.57.57,0,0,1,91.11,63.58ZM6,62.44H90.55V2.92H6Z"
            />
          </g>
          <g id="Group_616" data-name="Group 616">
            <rect
              id="Rectangle_112"
              data-name="Rectangle 112"
              fill="#fff"
              x="5.4"
              y="2.35"
              width="85.71"
              height="60.66"
            />
            <path
              id="Path_2470"
              data-name="Path 2470"
              fill="#dcd9d5"
              d="M91.11,63.58H5.4A.58.58,0,0,1,4.83,63V2.35a.58.58,0,0,1,.57-.57H91.11a.57.57,0,0,1,.57.57h0V63A.57.57,0,0,1,91.11,63.58ZM6,62.44H90.55V2.92H6Z"
            />
          </g>
          <g id="Group_617" data-name="Group 617">
            <rect
              id="Rectangle_113"
              data-name="Rectangle 113"
              fill="#dcd9d5"
              x="9.4"
              y="6.35"
              width="77.71"
              height="52.66"
            />
            <path
              id="Path_2471"
              data-name="Path 2471"
              fill="#dcd9d5"
              d="M87.11,59.58H9.4A.58.58,0,0,1,8.83,59V6.35a.58.58,0,0,1,.57-.57H87.11a.57.57,0,0,1,.57.57h0V59A.57.57,0,0,1,87.11,59.58ZM10,58.44H86.54V6.92H10Z"
            />
          </g>
          <path
            id="Path_2472"
            data-name="Path 2472"
            fill="#dcd9d5"
            d="M95.44,63.54H1.08A.54.54,0,0,1,.54,63h0a.54.54,0,0,1,.54-.54H95.44A.54.54,0,0,1,96,63h0A.53.53,0,0,1,95.44,63.54Z"
          />
        </g>
      </g>
      <rect fill="#27375f" x="0.26" y="0.26" width="95.66" height="3.74" />
      <path
        fill="#fff"
        d="M95.66.52V3.74H.52V.52H95.66M96.18,0H0V4.26H96.18V0Z"
      />
      <rect fill="#27375f" x="0.33" y="37.67" width="95.82" height="1.98" />
      <path
        fill="#fff"
        d="M96,37.86v1.61H.52V37.86H96m.37-.37H.15v2.35H96.34V37.49Z"
      />
      <polygon
        fill="#27375f"
        points="0.83 13.98 1.63 10.9 95.6 10.9 94.12 13.98 0.83 13.98"
      />
      <path
        fill="#fff"
        d="M95.19,11.15,94,13.72H1.17l.66-2.57H95.19m.81-.51H1.43l-.1.38L.67,13.59l-.17.65H94.28l.14-.3,1.23-2.57.35-.73Z"
      />
      <polygon
        fill="#27375f"
        points="1.63 17.44 0.83 14.35 94.12 14.35 95.6 17.44 1.63 17.44"
      />
      <path
        fill="#fff"
        d="M94,14.61l1.23,2.57H1.83l-.66-2.57H94m.32-.51H.5l.17.64.66,2.57.1.38H96L95.65,17l-1.23-2.57-.14-.29Z"
      />
      <polygon
        fill="#27375f"
        points="0.83 7.3 1.63 4.22 95.6 4.22 94.12 7.3 0.83 7.3"
      />
      <path
        fill="#fff"
        d="M95.19,4.48,94,7.05H1.17l.66-2.57H95.19M96,4H1.43l-.1.39L.67,6.92.5,7.56H94.28l.14-.29L95.65,4.7,96,4Z"
      />
      <polygon
        fill="#27375f"
        points="1.63 10.76 0.83 7.68 94.12 7.68 95.6 10.76 1.63 10.76"
      />
      <path
        fill="#fff"
        d="M94,7.93l1.23,2.57H1.83L1.17,7.93H94m.32-.51H.5l.17.64.66,2.57.1.39H96l-.35-.74L94.42,7.71l-.14-.29Z"
      />
      <polygon
        fill="#27375f"
        points="0.83 20.66 1.63 17.57 95.6 17.57 94.12 20.66 0.83 20.66"
      />
      <path
        fill="#fff"
        d="M95.19,17.83,94,20.4H1.17l.66-2.57H95.19m.81-.51H1.43l-.1.38L.67,20.27l-.17.64H94.28l.14-.29,1.23-2.57.35-.73Z"
      />
      <polygon
        fill="#27375f"
        points="1.63 24.11 0.83 21.03 94.12 21.03 95.6 24.11 1.63 24.11"
      />
      <path
        fill="#fff"
        d="M94,21.29l1.23,2.57H1.83l-.66-2.57H94m.32-.52H.5l.17.64L1.33,24l.1.39H96l-.35-.73-1.23-2.58-.14-.29Z"
      />
      <polygon
        fill="#27375f"
        points="0.83 27.33 1.63 24.25 95.6 24.25 94.12 27.33 0.83 27.33"
      />
      <path
        fill="#fff"
        d="M95.19,24.5,94,27.07H1.17l.66-2.57H95.19M96,24H1.43l-.1.39L.67,27l-.17.64H94.28l.14-.29,1.23-2.57L96,24Z"
      />
      <polygon
        fill="#27375f"
        points="1.63 30.79 0.83 27.7 94.12 27.7 95.6 30.79 1.63 30.79"
      />
      <path
        fill="#fff"
        d="M94,28l1.23,2.57H1.83L1.17,28H94m.32-.51H.5l.17.64.66,2.57.1.39H96l-.35-.74-1.23-2.57-.14-.29Z"
      />
      <polygon
        fill="#27375f"
        points="0.83 34.01 1.63 30.92 95.6 30.92 94.12 34.01 0.83 34.01"
      />
      <path
        fill="#fff"
        d="M95.19,31.18,94,33.75H1.17l.66-2.57H95.19m.81-.51H1.43l-.1.38L.67,33.62l-.17.64H94.28l.14-.29,1.23-2.57.35-.73Z"
      />
      <polygon
        fill="#27375f"
        points="1.63 37.47 0.83 34.38 94.12 34.38 95.6 37.47 1.63 37.47"
      />
      <path
        fill="#fff"
        d="M94,34.64l1.23,2.57H1.83l-.66-2.57H94m.32-.51H.5l.17.64.66,2.57.1.38H96L95.65,37l-1.23-2.57-.14-.29Z"
      />
      <circle
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#27375f"
        fill="#fff"
        cx="86.69"
        cy="38.42"
        r="16.07"
      />
      <rect
        strokeWidth="0.48px"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#27375f"
        x="82.8"
        y="3.83"
        width="1.56"
        height="27.02"
      />
      <rect
        strokeWidth="0.59px"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#27375f"
        x="88.26"
        y="3.83"
        width="1.56"
        height="40.29"
      />
      <path
        strokeMiterlimit="10"
        strokeWidth="0.4px"
        stroke="#fff"
        fill="#27375f"
        d="M83.19,26.64H84a2.11,2.11,0,0,1,2.11,2.11v8.57a0,0,0,0,1,0,0h-5a0,0,0,0,1,0,0V28.75a2.11,2.11,0,0,1,2.11-2.11Z"
      />
      <path
        strokeMiterlimit="10"
        strokeWidth="0.4px"
        stroke="#fff"
        fill="#27375f"
        d="M88.66,38.89h.77A2.11,2.11,0,0,1,91.54,41v8.57a0,0,0,0,1,0,0h-5a0,0,0,0,1,0,0V41A2.11,2.11,0,0,1,88.66,38.89Z"
      />
    </svg>
  );
};
